export default __webpack_public_path__ + "static/media/books-34.51cf20fc.jpg";